<div class="confirmation-dialog">
  <img
    class="confirmation-dialog__art"
    src="assets/images/payment-failed.svg"
    alt="" />

  <h4 class="confirmation-dialog__title">
    {{ dialogData?.title ?? 'Confirm Delete' }}
  </h4>

  <p
    class="confirmation-dialog__message"
    [innerHTML]="
      dialogData?.message ?? 'Are you sure you are going to delete it?'
    "></p>

  <div class="confirmation-dialog__actions">
    <button type="button" class="btn ghost-btn" (click)="dialogRef.close(false)">
      {{ dialogData?.cancelButtonText ?? 'Cancel' }}
    </button>
    <button type="button" class="btn primary-btn" (click)="dialogRef.close(true)">
      {{ dialogData?.submitButtonText ?? 'Delete' }}
    </button>
  </div>
</div>
